"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { WorkspaceElementType } from '@membranehq/sdk';
import { useElement } from '../element/useElement.mjs';

function useScreen(selector) {
  const { item: screen, ...rest } = useElement(WorkspaceElementType.Screen, selector, (integrationApp) => selector ? integrationApp.screen(selector) : void 0);
  return { screen, ...rest };
}

export { useScreen };
